import { useLocalizedData } from "contexts/LocalizationContext/hooks";
import config from "config/config";
import { getDynamicVariable } from "config/dynamicVariables";

export const AHPLUS_PRICE = 19.99;
export const AHPLUS_HIGHER_PRICE = 29.99;
export const AHPLUS_COMPLETE_PRICE = 49.99;
export const AHPLUS_PER_MONTH_PRICE = 1.66;
export const AHPLUS_COMPLETE_PER_MONTH_PRICE = 4.16;

export const PRICING_PLANS_ANCHOR = "pricing-plans";
export const FEATURES_ANCHOR = "features";
export const REVIEWS_ANCHOR = "reviews";
export const FAQ_ANCHOR = "faq";

export const LOUNGE_ACCESS_REFUND = 35;

export const ESSENTIAL_PLAN_PATH = "/memberships/buy?channel=lp_essential";
export const COMPLETE_PLAN_PATH = "/memberships/buy?channel=lp_complete";

export const OG_IMAGE_URL = `${config.staticUrl}/i/airhelp-plus/airhelp-plus-share.png`;

export const BOTTOM_BAR_CHECKMARKS = ["all_airlines", "all_countries", "all_flights"];

export const usePricingPlanDetailsConfig = () => {
  const { getLocalizedCurrency } = useLocalizedData();

  return {
    essential: {
      planType: "essential",
      translationVariables: {
        "%price%": getLocalizedCurrency(AHPLUS_PRICE, "EUR", 2),
        "%higher-price%": getLocalizedCurrency(AHPLUS_HIGHER_PRICE, "EUR", 2),
      },
      price: AHPLUS_PRICE,
      pricePerMonth: getLocalizedCurrency(AHPLUS_PER_MONTH_PRICE, "EUR", 2),
      nameText: "plan_essential",
      buttonText: "button_choose_essential",
      buttonType: "primary",
      buttonPath: ESSENTIAL_PLAN_PATH,
      items: [
        {
          text: "plan_compensation_claims",
          translationVariables: {
            "%compensation%": getDynamicVariable("{{compensation_value}}"),
          },
        },
        {
          text: "plan_expenses_claims",
          translationVariables: {
            "%extra-expenses%": getDynamicVariable("{{extra_expenses_compensation_value}}"),
          },
        },
        {
          text: "plan_luggage_claims",
          translationVariables: {
            "%luggage-compensation%": getDynamicVariable("{{luggage_compensation_value}}"),
          },
        },
        {
          text: "plan_assistance_with_refunds",
        },
        {
          text: "plan_live_chat",
          popover: "plan_hover_live_chat",
        },
      ],
    },
    complete: {
      planType: "complete",
      price: AHPLUS_COMPLETE_PRICE,
      pricePerMonth: getLocalizedCurrency(AHPLUS_COMPLETE_PER_MONTH_PRICE, "EUR", 2),
      nameText: "plan_complete",
      buttonText: "button_choose_complete",
      buttonType: "primary",
      buttonPath: COMPLETE_PLAN_PATH,
      items: [
        {
          text: "plan_all_essential_benefits",
          highlighted: true,
        },
        {
          text: "plan_airport_lounge_access",
          popover: "plan_airport_lounge_access_hover",
          translationVariables: {
            "%lounge-refund%": getLocalizedCurrency(LOUNGE_ACCESS_REFUND, "EUR"),
          },
        },
        {
          text: "plan_range_of_lounge_amenities_included",
          popover: "plan_range_of_lounge_amenities_included_hover",
        },
      ],
    },
  };
};
